import React, { useEffect, useState } from "react";
import LmsClientMapping from "../component/lmsClientMapping/lmsClientMapping";
import * as clientAction from "../../../redux/actions/clientAction";
import { useDispatch, useSelector } from "react-redux";
import * as lmsAction from "../../../redux/actions/lmsAction";
import {
  API_STATUS,
  HBNEXT_ORG_ID,
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
} from "../../../constant/constant";
import Loader from "../../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifyError } from "../../../../src/library/custom/toastMessage/Toast";
import { checkPrivileges, hasAllPrivileges } from "../../../utils/rolesHelper";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ACCESS_DENIED } from "../../../constant/routeContant";
const LmsClientMappingContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const locationDetail = location?.state;

  const [trainigtype, setTrainigtype] = useState(1);
  const [lessons, setlessons] = useState("");
  const [courses, setcourses] = useState("");
  const [changesearchauto, setchangesearchauto] = useState({
    key: "",
    value: "",
  });

  const [clients, setClients] = useState("");
  const [tabclick, settabclick] = useState(1);
  const [isTableLoading, setisTableLoading] = useState(false);
  // Final Grid Data
  const [FinalaData, setFinalaData] = useState([]);
  const [FinalaCourseData, setFinalaCourseData] = useState([]);
  const [FinalaDataClientSide, setFinalaDataClientSide] = useState([]);
  const [FinalaCourseDataClientSide, setFinalaCourseDataClientSide] = useState(
    []
  );
  const [lessonid, setlessonid] = useState("");
  const [courseid, setcourseid] = useState("");
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState();
  const [categoryId, setIsCategoryId] = useState();
  const [serviceTypeId, setServiceTypeId] = useState();
  const [isMapped, setIsMapped] = useState();
  const [lessonCount, setLessonCount] = useState([]);
  const [courseCount, setCourseCount] = useState([]);
  const [clearLessonToast, setClearLessonToast] = useState(false);
  const [clearCourseToast, setClearCourseToast] = useState(false);
  const [searchClients, setSearchClients] = useState();
  const [lessonCourseMapped, setLessonCourseMapped] = useState(new Set());
  const [clientMapped, setClientMapped] = useState(new Set());
  const [selectedClientRows, setSelectedClientRows] = useState(new Set());
  const [selectedLessonCourseRows, setSelectedLessonCourseRows] = useState(
    new Set()
  );

  const lessonOrgMapping = useSelector((state) => state.lessonOrgMapping);
  const postLessonOrgMapping = async (data, clientId) => {
    dispatch(lmsAction.lessonOrgMapping(data, clientId));
  };

  const courseOrgMapping = useSelector((state) => state.courseOrgMapping);
  const postCourseOrgMapping = async (data, clientId) => {
    dispatch(lmsAction.courseOrgMapping(data, clientId));
  };

  const categoryListData = useSelector((state) => state.getCategoryList?.data);

  const allClients = useSelector((state) => state?.searchAllClientsReducerData);
  const isSearchClientLoading = allClients?.isLoading;

  const searchLessonsData = useSelector(
    (state) => state?.searchLessons?.data?.users
  );
  const isSearchLessonsLoading = useSelector(
    (state) => state?.searchLessons?.isLoading
  );

  const searchCoursesData = useSelector(
    (state) => state?.searchCourses?.data?.users
  );
  const isSearchCoursesLoading = useSelector(
    (state) => state?.searchCourses?.isLoading
  );

  const MappedGlobalLessonListData = useSelector(
    (state) => state?.MappedGlobalLessonList ?? []
  );

  const MappedGlobalCourseListData = useSelector(
    (state) => state?.MappedGlobalCoursesList ?? []
  );

  const searchClient = (searchText) => {
    dispatch(clientAction.searchAllClients(searchText));
  };

  const searchLessons = (searchText) => {
    dispatch(lmsAction.searchLessons((searchText ?? "").toLowerCase()));
  };
  const searchCourses = (searchText) => {
    dispatch(lmsAction.searchCourses((searchText ?? "").toLowerCase()));
  };

  const getMappedGlobalLessonListApi = (data) => {
    setClearLessonToast(true);
    dispatch(lmsAction.getMappedGlobalLessonList(data));
  };

  const getMappedGlobalCourseListApi = (data) => {
    setClearCourseToast(true);
    dispatch(lmsAction.getMappedGlobalCourseList(data));
  };

  function renameKey(arr, oldKey, newKey) {
    return arr?.map((obj) => {
      const { [oldKey]: oldVal, ...rest } = obj;
      return { [newKey]: oldVal, ...rest };
    });
  }
  useEffect(() => {
    dispatch(lmsAction.clearGetMappedGlobalLessonList(""));
    setFinalaData([]);
    setFinalaCourseData([]);
    setFinalaDataClientSide([]);
    setFinalaCourseDataClientSide([]);
  }, []);

  useEffect(() => {
    if (MappedGlobalLessonListData?.status === API_STATUS.SUCCESS) {
      //changesearchauto?.key
      const FinalUpdateData = renameKey(
        MappedGlobalLessonListData?.data?.globalLessonList,
        "clientOrgId",
        "clientOrgId"
      );
      if (changesearchauto?.key) {
        setFinalaData(FinalUpdateData);
      } else {
        setFinalaDataClientSide(FinalUpdateData);
      }
    }
  }, [MappedGlobalLessonListData]);

  useEffect(() => {
    if (MappedGlobalCourseListData?.status === API_STATUS.SUCCESS) {
      const FinalUpdateData = renameKey(
        MappedGlobalCourseListData?.data?.globalCourseList,
        "clientOrgId",
        "clientOrgId"
      );
      if (changesearchauto?.key) {
        setFinalaCourseData(FinalUpdateData);
      } else {
        setFinalaCourseDataClientSide(FinalUpdateData);
      }
    }
  }, [MappedGlobalCourseListData]);

  const showLoader = useSelector(
    (state) =>
      state.getCategoryList?.isLoading ||
      state.courseOrgMapping?.isLoading ||
      state.lessonOrgMapping?.isLoading
  );

  useEffect(() => {
    dispatch(lmsAction.getCategoryList({ isGlobal: true }));
  }, []);
  useEffect(() => {
    if (lessonOrgMapping?.status === API_STATUS.FAILURE) {
      notifyError();
    } else if (
      lessonOrgMapping?.status === API_STATUS.SUCCESS &&
      trainigtype === 1 &&
      clearLessonToast
    ) {
      toast("Lesson Mapped Successfully");
      setisTableLoading(true);
      setTimeout(() => {
        setisTableLoading(false);
      }, 1);
      setServiceTypeId("");
      setIsCategoryId("");
      setIsMapped("");
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      if (changesearchauto?.key && tabclick === 1) {
        const data = {
          clientId: parseInt(changesearchauto?.key),
          page: 1,
          pageSize: GRID_DEFAULT_PAGE_SIZE,
          lesson: "",
          isMapped: "",
          categoryId: "",
          serviceTypeId: "",
          lessonId: 0,
        };

        getMappedGlobalLessonListApi(data);
        setClients({
          key: changesearchauto?.key,
          value: changesearchauto?.value,
        });
        setchangesearchauto({
          key: changesearchauto?.key,
          value: changesearchauto?.value,
        });
        setTrainigtype(1);
      }

      if (lessonid && tabclick === 2) {
        const data = {
          clientId: 0,
          page: 1,
          pageSize: GRID_DEFAULT_PAGE_SIZE,
          lesson: "",
          isMapped: "",
          categoryId: "",
          serviceTypeId: "",
          lessonId: lessonid,
        };
        getMappedGlobalLessonListApi(data);
        setlessons({ key: lessons?.key, value: lessons?.value });
        setlessonid(lessonid);
        setTrainigtype(1);
      }
    }
    if (courseOrgMapping?.status === API_STATUS.FAILURE) {
      notifyError();
    } else if (
      courseOrgMapping?.status === API_STATUS.SUCCESS &&
      trainigtype === 2 &&
      clearCourseToast
    ) {
      toast("Course Mapped Successfully");
      setisTableLoading(true);
      setTimeout(() => {
        setisTableLoading(false);
      }, 1);
      setServiceTypeId("");
      setIsCategoryId("");
      setIsMapped("");
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      if (changesearchauto?.key && tabclick === 1) {
        const data = {
          clientId: parseInt(changesearchauto?.key),
          page: 1,
          pageSize: GRID_DEFAULT_PAGE_SIZE,
          course: "",
          isMapped: "",
          categoryId: "",
          serviceTypeId: "",
          courseId: 0,
        };
        getMappedGlobalCourseListApi(data);
        setClients({
          key: changesearchauto?.key,
          value: changesearchauto?.value,
        });
        setchangesearchauto({
          key: changesearchauto?.key,
          value: changesearchauto?.value,
        });
        setTrainigtype(2);
      }

      if (courseid && tabclick === 2) {
        const data = {
          clientId: 0,
          page: 1,
          pageSize: GRID_DEFAULT_PAGE_SIZE,
          course: "",
          isMapped: "",
          categoryId: "",
          serviceTypeId: "",
          courseId: courseid,
        };
        getMappedGlobalCourseListApi(data);
        setcourses({ key: courses?.key, value: courses?.value });
        setcourseid(courseid);
        setTrainigtype(2);
      }
    }
  }, [lessonOrgMapping, courseOrgMapping]);

  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showSafety =
    isShowClient || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI);
  const showSW = isShowClient || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI);

  useEffect(() => {
    if (trainigtype === 1) {
      setLessonCount(MappedGlobalLessonListData?.data?.noOfRecords);
    } else {
      setCourseCount(MappedGlobalCourseListData?.data?.noOfRecords);
    }
  }, [MappedGlobalLessonListData, MappedGlobalCourseListData]);

  useEffect(() => {
    setCourseCount();
    setLessonCount();
  }, []);

  useEffect(() => {
    if (locationDetail?.route) {
      setLessonCourseMapped(locationDetail?.lessonCourseMapped);
      setClientMapped(locationDetail?.clientMapped);
      setSelectedClientRows(locationDetail?.selectedClientRows);
      setSelectedLessonCourseRows(locationDetail?.selectedLessonCourseRows);
      setPage(locationDetail?.page ?? 0);
      setPageSize(locationDetail?.pageSize ?? GRID_DEFAULT_PAGE_SIZE);
      setIsCategoryId(locationDetail?.categoryId);
      setIsMapped(locationDetail?.isMapped);
      settabclick(locationDetail?.tabclick);
      setTrainigtype(locationDetail?.trainigtype);

      if (
        locationDetail?.clientId?.key &&
        locationDetail?.tabclick === 1 &&
        locationDetail?.trainigtype === 1
      ) {
        const data = {
          clientId: parseInt(locationDetail?.clientId?.key),
          page: locationDetail?.page ?? 1,
          pageSize: locationDetail?.pageSize ?? GRID_DEFAULT_PAGE_SIZE,
          lesson: locationDetail?.search ?? "",
          isMapped:
            locationDetail?.isMapped === 1
              ? true
              : locationDetail?.isMapped === 2
              ? false
              : "",
          categoryId: locationDetail?.categoryId ?? "",
          serviceTypeId:
            parseInt(locationDetail?.serviceTypeId) === 3
              ? ""
              : locationDetail?.serviceTypeId || "",
          lessonId: 0,
        };

        getMappedGlobalLessonListApi(data);
        setClients({
          key: locationDetail?.clientId?.key,
          value: locationDetail?.clientId?.value,
        });
        setchangesearchauto({
          key: locationDetail?.clientId?.key,
          value: locationDetail?.clientId?.value,
        });
        setTrainigtype(locationDetail?.trainigtype);
        setSearch(locationDetail?.search);
        setSearchClients(locationDetail?.searchClients);
      }

      if (
        locationDetail?.lessonId &&
        locationDetail?.tabclick === 2 &&
        locationDetail?.trainigtype === 1
      ) {
        const data = {
          clientId: 0,
          client: locationDetail?.searchClients,
          page: locationDetail?.page ?? 1,
          pageSize: locationDetail?.pageSize ?? GRID_DEFAULT_PAGE_SIZE,
          lesson: locationDetail?.search ?? "",
          isMapped:
            locationDetail?.isMapped === 1
              ? true
              : locationDetail?.isMapped === 2
              ? false
              : "",
          categoryId: locationDetail?.categoryId ?? "",
          serviceTypeId:
            parseInt(locationDetail?.serviceTypeId) === 3
              ? ""
              : locationDetail?.serviceTypeId || "",
          lessonId: locationDetail?.lessonId,
        };
        getMappedGlobalLessonListApi(data);
        setlessons({
          key: locationDetail?.lessons?.key,
          value: locationDetail?.lessons?.value,
        });
        setlessonid(locationDetail?.lessonId);
        setTrainigtype(locationDetail?.trainigtype);
        setSearch(locationDetail?.search);
        setServiceTypeId(locationDetail?.serviceTypeId);
        setSearchClients(locationDetail?.searchClients);
      }

      if (
        locationDetail?.clientId?.key &&
        locationDetail?.tabclick === 1 &&
        locationDetail?.trainigtype === 2
      ) {
        const data = {
          clientId: parseInt(locationDetail?.clientId?.key),
          page: locationDetail?.page ?? 1,
          pageSize: locationDetail?.pageSize ?? GRID_DEFAULT_PAGE_SIZE,
          course: locationDetail?.search ?? "",
          isMapped:
            locationDetail?.isMapped === 1
              ? true
              : locationDetail?.isMapped === 2
              ? false
              : "",
          categoryId: locationDetail?.categoryId ?? "",
          serviceTypeId:
            parseInt(locationDetail?.serviceTypeId) === 3
              ? ""
              : locationDetail?.serviceTypeId || "",
          courseId: 0,
        };
        getMappedGlobalCourseListApi(data);
        setClients({
          key: locationDetail?.clientId?.key,
          value: locationDetail?.clientId?.value,
        });
        setchangesearchauto({
          key: locationDetail?.clientId?.key,
          value: locationDetail?.clientId?.value,
        });
        setTrainigtype(locationDetail?.trainigtype);
        setSearch(locationDetail?.search);
        setServiceTypeId(locationDetail?.serviceTypeId);
        setSearchClients(locationDetail?.searchClients);
      }

      if (
        locationDetail?.courseId &&
        locationDetail?.tabclick === 2 &&
        locationDetail?.trainigtype === 2
      ) {
        const data = {
          clientId: 0,
          page: locationDetail?.page ?? 1,
          pageSize: locationDetail?.pageSize ?? GRID_DEFAULT_PAGE_SIZE,
          course: locationDetail?.search ?? "",
          isMapped:
            locationDetail?.isMapped === 1
              ? true
              : locationDetail?.isMapped === 2
              ? false
              : "",
          categoryId: locationDetail?.categoryId ?? "",
          serviceTypeId:
            parseInt(locationDetail?.serviceTypeId) === 3
              ? ""
              : locationDetail?.serviceTypeId || "",
          courseId: locationDetail?.courseId,
          client: locationDetail?.searchClients,
        };
        getMappedGlobalCourseListApi(data);
        setcourses({
          key: locationDetail?.courses?.key,
          value: locationDetail?.courses?.value,
        });
        setcourseid(courseid);
        setTrainigtype(locationDetail?.trainigtype);
        setServiceTypeId(locationDetail?.serviceTypeId);
        setSearch(locationDetail?.search);
        setSearchClients(locationDetail?.searchClients);
      }
    }
  }, [locationDetail?.route]);
  return (
    <>
      {showSafety || showSW ? (
        <>
          {showLoader && <Loader />}

          <LmsClientMapping
            searchClient={searchClient}
            allClients={allClients}
            isSearchClientLoading={isSearchClientLoading}
            changesearchauto={changesearchauto}
            setchangesearchauto={setchangesearchauto}
            setFinalaData={setFinalaData}
            FinalaData={FinalaData}
            FinalaCourseData={FinalaCourseData}
            setFinalaCourseData={setFinalaCourseData}
            searchLessons={searchLessons}
            searchLessonsData={searchLessonsData}
            searchCourses={searchCourses}
            searchCoursesData={searchCoursesData}
            getMappedGlobalLessonListApi={getMappedGlobalLessonListApi}
            getMappedGlobalCourseListApi={getMappedGlobalCourseListApi}
            MappedGlobalLessonListData={MappedGlobalLessonListData}
            MappedGlobalCourseListData={MappedGlobalCourseListData}
            setClients={setClients}
            clients={clients}
            setlessons={setlessons}
            lessons={lessons}
            setTrainigtype={setTrainigtype}
            trainigtype={trainigtype}
            FinalaDataClientSide={FinalaDataClientSide}
            FinalaCourseDataClientSide={FinalaCourseDataClientSide}
            setFinalaCourseDataClientSide={setFinalaCourseDataClientSide}
            setFinalaDataClientSide={setFinalaDataClientSide}
            lessonCount={lessonCount}
            courseCount={courseCount}
            setLessonCount={setLessonCount}
            setCourseCount={setCourseCount}
            categoryListData={categoryListData}
            postLessonOrgMapping={postLessonOrgMapping}
            postCourseOrgMapping={postCourseOrgMapping}
            tabclick={tabclick}
            settabclick={settabclick}
            courseid={courseid}
            setcourseid={setcourseid}
            lessonid={lessonid}
            setlessonid={setlessonid}
            isTableLoading={isTableLoading}
            setisTableLoading={setisTableLoading}
            courses={courses}
            setcourses={setcourses}
            page={page}
            setPage={setPage}
            search={search}
            setSearch={setSearch}
            categoryId={categoryId}
            setIsCategoryId={setIsCategoryId}
            serviceTypeId={serviceTypeId}
            setServiceTypeId={setServiceTypeId}
            isMapped={isMapped}
            setIsMapped={setIsMapped}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchClients={searchClients}
            setSearchClients={setSearchClients}
            isSearchCoursesLoading={isSearchCoursesLoading}
            isSearchLessonsLoading={isSearchLessonsLoading}
            lessonCourseMapped={lessonCourseMapped}
            clientMapped={clientMapped}
            selectedClientRows={selectedClientRows}
            selectedLessonCourseRows={selectedLessonCourseRows}
            setLessonCourseMapped={setLessonCourseMapped}
            setClientMapped={setClientMapped}
            setSelectedClientRows={setSelectedClientRows}
            setSelectedLessonCourseRows={setSelectedLessonCourseRows}
          />
          <ToastContainer />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default LmsClientMappingContainer;
